<template>
   <v-app>
     <v-container>
       <v-card>
         <v-card-title>Add a video idea
         <v-spacer></v-spacer>
         <v-btn icon to="/idealist">
           <v-icon>mdi-arrow-left</v-icon>
         </v-btn>
         </v-card-title>
       </v-card>
       <v-card>
         <v-card-text>
          <v-form>
            <v-container>
              <v-select
                :items="items"
                label="Video Type"
                id="type"
                name="type"
                v-model="type"
              >
              </v-select>
              <v-text-field
                label="Add Video Title"
                name="name"
                id="name"
                v-model="name"
                :rules="rule1"
                >
              </v-text-field>
              <v-textarea
                label="Add Description (Eg. location, resources, format, etc.)"
                name="description"
                id="description"
                v-model="description"
                :rules="rule2"
                >
              </v-textarea>
              <v-text-field
                label="Enter video inspiration link"
                v-model="video"
                id="video"
                name="video"
                class="ma-2"
                :rules="rule2"
              >
              </v-text-field>
              <video-embed
                v-if="video !== ''"
                :src="video"
                class="mx-16"
              >
              </video-embed>
              <h4>Choose vote deadline</h4>
              <v-date-picker
                class="ma-2"
                id="date"
                name="date"
                v-model="date"
              >
              </v-date-picker>
              <v-time-picker
                class="ma-2"
                format="24hr"
                id="time"
                name="time"
                v-model="time"
              >
              </v-time-picker>
            </v-container>
            <v-card-actions>
              <v-btn
                :disabled="!formIsValid"
                class="ma-2"
                color="green"
                @click="addIdea()"
              >
                <v-icon left>mdi-plus</v-icon>
                Add Idea
              </v-btn>
            </v-card-actions>
          </v-form>
         </v-card-text>
       </v-card>
     </v-container>
   </v-app>
</template>

<script>
export default {
  title: 'Add Video Idea',
  data () {
    return {
      type: null,
      name: '',
      time: null,
      date: null,
      description: '',
      video: '',
      items: ['Individual', 'Collaboration'],
      rule1: [
        value => !!value || 'Required',
        value => (value || '').length <= 40 || 'Max 40 characters'
      ],
      rule2: [
        value => !!value || 'Required',
        value => (value || '').length <= 1000 || 'Max 1000 characters'
      ]
    }
  },
  methods: {
    addIdea () {
      if (!this.formIsValid) {
        return
      }
      const info = {
        name: this.name,
        description: this.description,
        type: this.type,
        time: this.time,
        date: this.date,
        video: this.video
      }
      this.$store.dispatch('createVideoIdea', info)
      this.$router.push('/idealist')
    }
  },
  computed: {
    formIsValid () {
      return this.name !== '' &&
      this.type !== null &&
      this.description !== '' &&
      this.time !== null &&
      this.date !== null
    }
  }
}
</script>

<style>

</style>
